module.exports = __webpack_public_path__ + "static/media/user-manual-web.d0faedce.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/user-manual-web.pdf
// module id = 1617
// module chunks = 0